// @ts-nocheck
import React, { useState } from 'react';
import TerritoriesList from './components/TerritoriesList';
import ActionBar from '../../layout/ActionBar';
import EditTerritory from './slideout/EditTerritory';
import SlidingPane from 'react-sliding-pane';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../../util/pageTitle';

function Territories() {
  const [pageTitle, setPageTitle] = usePageTitle(['Territories', 'Settings']);
  const { t } = useTranslation();
  const [reload, setReload] = useState<Date | undefined>();
  const [addTerritorySlideoutOpen, setAddTerritorySlideoutOpen] =
    useState(false);

  return (
    <>
      <ActionBar>
        <Button
          className="btn btn-primary"
          onClick={() => setAddTerritorySlideoutOpen(true)}
          text={t('Add territory')}
          testId="add-territory-button"
        />
      </ActionBar>
      <TerritoriesList reload={reload} />

      <SlidingPane
        isOpen={addTerritorySlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setAddTerritorySlideoutOpen(false)}
      >
        <EditTerritory
          done={(d) => {
            setReload(new Date());
            setAddTerritorySlideoutOpen(false);
          }}
          cancel={() => setAddTerritorySlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default Territories;
